import React, { useEffect, useState } from 'react'
import { useSuppliers } from '../../../hooks'
import { useSuppliersOrigin } from '../../../hooks/useSuppliersOrigin'
import { useApi } from '../../../hooks/useApi'
import { getAsnToReceive, getIboundOrigins, getIboundSuppliers } from '../api'
import { StepperControls } from '../../../components/StepperTypes/StepperTypes'
import { PreviousStep } from './PreviousStep'
import {
  Box,
  IconButton,
  InputAdornment,
  TextField,
  Typography
} from '@mui/material'
import { ButtonFilter } from '../../../components/PutAway/screens/UnknowOt/ButtonFilter'
import { AsnReceiveFilters, AsnToReceive } from '../Interfaces'
import ClearIcon from '@mui/icons-material/Clear'
import { useStyles } from '../styles'
import { filterEnum, stepEnum } from '../enum'

interface AsnUnkownProps {
  controls: StepperControls
  openSnackBar: (msg: string | undefined, status: boolean) => void
}

export const AsnUnkown: React.FC<AsnUnkownProps> = ({
  controls,
  openSnackBar
}) => {
  const classes = useStyles()
  const { callApi } = useApi()
  const unknownFilterValues = [
    { text: 'LPN', value: filterEnum.lpn },
    { text: 'SKU', value: filterEnum.sku }
  ]
  const [filterOption, setFilterOption] = useState<number>(0)
  const [filter, setFilter] = useState('')

  const {
    suppliersState: { suppliers },
    getSuppliers
  } = useSuppliers()
  const {
    suppliersOriginState: { suppliersOrigin },
    getSuppliersOrigin
  } = useSuppliersOrigin()

  const requestAsnToReceive = (
    lpn?: string,
    sku?: string,
    supplierId?: number,
    supplierOriginId?: number,
    supplier?: string,
    supplierOrigin?: string
  ) => {
    const filters: AsnReceiveFilters = {
      lpn: lpn,
      sku: sku,
      supplierId: supplierId,
      supplierOriginId: supplierOriginId,
      supplier: supplier,
      supplierOrigin: supplierOrigin
    }
    callApi(getAsnToReceive(filters))
      .then((response: AsnToReceive[]) => {
        if (response.length > 1) {
          controls.goToStep(stepEnum.asnSelection, filters)
        } else {
          controls.goToStep(stepEnum.asnSummary, response[0].asnId)
        }
      })
      .catch((error: any) => {
        openSnackBar(error, false)
      })
  }

  const getUnknown = () => {
    switch (filterOption) {
      case filterEnum.supplier:
        getIboundSuppliers()
        break
      case filterEnum.supplierOrigin:
        getIboundOrigins()
        break

      default:
        break
    }
  }

  useEffect(() => {
    if (suppliers?.length === 0) {
      getSuppliers()
    }
    if (suppliersOrigin?.length === 0) {
      getSuppliersOrigin()
    }
    getUnknown()
  }, [])

  return (
    <div>
      <PreviousStep controls={controls} specificStep={stepEnum.asnSearch} />
      <Box
        component='div'
        display='flex'
        flexDirection='column'
        flexWrap='nowrap'
        alignItems='left'
        padding='10px'
      >
        <Typography
          variant='h5'
          style={{
            fontSize: '20px',
            fontWeight: 'bold',
            marginTop: '30px'
          }}
        >
          {' '}
          Buscar por:{' '}
        </Typography>
      </Box>
      <div className={classes.BtnsContainer}>
        {unknownFilterValues.map(({ text, value }) => (
          <ButtonFilter
            key={text}
            isSelected={value === filterOption}
            text={text}
            onClick={() => {
              setFilter('')
              setFilterOption(value)
            }}
          />
        ))}

        {suppliers?.length! > 1 && (
          <ButtonFilter
            key={'Proveedor'}
            isSelected={filterOption === filterEnum.supplier}
            text={'Proveedor'}
            onClick={() => {
              setFilterOption(3)
            }}
          />
        )}
        {suppliersOrigin?.length! > 1 && (
          <ButtonFilter
            key={'Origen'}
            isSelected={filterOption === filterEnum.supplierOrigin}
            text={'Origen'}
            onClick={() => {
              setFilterOption(4)
            }}
          />
        )}
      </div>
      {(filterOption === filterEnum.lpn || filterOption === filterEnum.sku) && (
        <div className={classes.container}>
          <form
            onSubmit={(e) => {
              e.preventDefault()
              filterOption === filterEnum.lpn
                ? requestAsnToReceive(filter)
                : requestAsnToReceive(undefined, filter)
            }}
            style={{ marginTop: '20px' }}
          >
            <TextField
              id='searchValue'
              name='searchValue'
              value={filter}
              type='text'
              onChange={(e) => {
                setFilter(e.target.value)
              }}
              variant='outlined'
              fullWidth
              label={`Ingresar/Escanear ${
                filterOption === filterEnum.lpn ? 'LPN' : 'SKU'
              }`}
              autoFocus
              autoComplete='off'
              InputProps={{
                endAdornment: filter.length > 0 && (
                  <InputAdornment position='end'>
                    <IconButton onClick={() => setFilter('')}>
                      <ClearIcon />
                    </IconButton>
                  </InputAdornment>
                )
              }}
              style={{ left: '7px' }}
            />
          </form>
        </div>
      )}
      {filterOption >= filterEnum.supplier && (
        <div className={classes.container}>
          {filterOption === filterEnum.supplier &&
            (suppliers || []).map((supplier) => (
              <div
                className={classes.supplierBtn}
                onClick={() =>
                  requestAsnToReceive(
                    undefined,
                    undefined,
                    supplier.supplierId,
                    undefined,
                    supplier.supplierName
                  )
                }
              >
                {supplier.supplierName}
              </div>
            ))}
          {filterOption === filterEnum.supplierOrigin &&
            (suppliersOrigin || []).map((origin) => (
              <div
                className={classes.supplierBtn}
                onClick={() =>
                  requestAsnToReceive(
                    undefined,
                    undefined,
                    undefined,
                    origin.id,
                    undefined,
                    origin.supplierOriginName
                  )
                }
              >
                {origin.supplierOriginName}
              </div>
            ))}
        </div>
      )}
    </div>
  )
}
